















































































import Vue, { PropType } from 'vue';
import { ActionType, ApptStatusMessage, envisionOrgId, EventType, JobStatus, Routes } from '@/constants';
import { DreesContacts, HomeSummary, JobProgress, JobAppointment, Appointment, Milestones } from '@/types';
import CardLayout from '@/components/card-layout/CardLayout.vue'
import MainContent from '@/views/dashboard/components/MainContent.vue';
import HomeProfile from './sidebar-components/HomeProfile.vue';
import AppointmentSummary from './sidebar-components/AppointmentSummary.vue';
import FinancingAndPayments from './sidebar-components/FinancingAndPayments.vue';
import CustomerCare from './sidebar-components/CustomerCare.vue';
import DreesTeam from './sidebar-components/DreesTeam.vue';
import { getRememberMe, userHomeSelection } from '@/util';
import { getHomeDetails, getUserData, getJobContacts, getAppointments, getPendingAppointments } from '@/api';
import { jobOwnershipStatus } from '../services/service';
import { mapGetters } from 'vuex';
import { getAppointmentStatus } from '@/views/appointments/services/service';
import { bus } from '@/main';
import { format } from 'date-fns';

export default Vue.extend({
  name: 'LeftSidebar',
  components: {
    MainContent,
    CardLayout,
    HomeProfile,
    AppointmentSummary,
    FinancingAndPayments,
    CustomerCare,
    DreesTeam
  },
  data () {
    return {
      strokeOffset: 0,
      homeDetail: {} as HomeSummary,
      appointmentSummary: {} as JobAppointment,
      dreesContacts: [] as DreesContacts[],
      closeDate: '',
      pendingAppointments: [] as Appointment[],
      unavailableAppointments: [] as Appointment[],
      showMessage: process.env.VUE_APP_SHOW_MESSAGE,
      showAppointment: process.env.VUE_APP_SHOW_APPOINTMENT,
      showRecognizeTeamMemberSection: process.env.VUE_APP_SHOW_RECOGNIZE_A_TEAM,
      EventType,
      envisionLoginRedirectUrl: process.env.VUE_APP_ENVISION_URL || '',
      envisionDivisions: process.env.VUE_APP_ENVISION_DIVISIONS?.split(',') || ''
    }
  },
  props: {
    phaseProgress: {
      type: Object as PropType<JobProgress>
    }
  },
  created () {
    bus.$on(EventType.APPOINTMENT_CANCELLED, (appointmentId: string) => {
      const deletedAppointment = this.appointmentSummary.appointments.findIndex((appt) => appt.appointmentId === appointmentId);
      const el = this.appointmentSummary.appointments.splice(deletedAppointment, 1);
    });
  },
  async beforeMount () {
    await this.fetchHomeSummary();
    this.fetchPendingAppintments();
    this.fetchDreesContacts();
    this.fetchAppointments();
  },
  watch: {
    mileStones () {
      this.mileStones.Own && this.mileStones.Own.steps.forEach((step: Milestones) => {
        for (const [key, value] of Object.entries(step)) {
          if (value === 'Own_Closing' && step.actualCloseDate) {
            this.closeDate = format(new Date(step.actualCloseDate), 'MM/dd/yyyy') as string
          }
        }
      });
    }
  },
  computed: {
    ...mapGetters(['badges', 'hasUserData', 'selectedJob', 'isLoggedInAsAdmin', 'selectedJobDetails', 'mileStones', 'user']),
    getAreaId (): string {
      return this.homeDetail.areaId || '';
    },
    preClose (): boolean {
      return [JobStatus.PRE_CLOSE].includes(jobOwnershipStatus());
    },
    postClose (): boolean {
      return [JobStatus.POST_CLOSE].includes(jobOwnershipStatus());
    },
    envisionLoginUrl (): string {
      const orgId = envisionOrgId.find(entry => entry.area === this.homeDetail.areaId)?.orgId;
      return this.envisionLoginRedirectUrl?.replaceAll('[orgId]', orgId) || '';
    }
  },
  methods: {
    fetchAppointments () {
      getAppointments(this.selectedJob).then((data: any) => {
        if (data) {
          this.appointmentSummary = data;
        }
      })
    },
    async fetchPendingAppintments () {
      const response = await getPendingAppointments(this.selectedJob, this.selectedJobDetails?.divisionId, this.user.email);
      const data = response.appointments as Appointment[];
      data.forEach(element => {
        if (getAppointmentStatus(element) === ApptStatusMessage.Pending) {
          this.pendingAppointments.push(element);
        } else {
          this.unavailableAppointments.push(element);
        }
      });
    },
    async fetchHomeSummary () {
      let selectedHome = getRememberMe();
      if (!selectedHome) {
        if (!this.hasUserData) {
          await getUserData();
          selectedHome = userHomeSelection();
        }
      } else {
        getHomeDetails(selectedHome).then((response: HomeSummary) => {
          if (response) {
            this.homeDetail = response;
            this.$store.dispatch(ActionType.SET_JOB_DETAILS, this.homeDetail);
          }
        })
      }
    },
    fetchDreesContacts () {
      const jobId = getRememberMe();
      if (jobId) {
        getJobContacts(jobId).then((response) => {
          if (response && response.members) {
            this.dreesContacts = response.members;
          }
        });
      }
    },
    showAppointmentDetails (appointmentId: string) {
      bus.$emit(EventType.APPOINTMENT_DETAILS, appointmentId, Routes.DASHBOARD);
    }
  }
});
